module.exports = __webpack_public_path__ + "img/flight-plane-svgrepo-com.f45155d1.svg";